import ScreendoorBlock from "./ScreendoorBlock";

export default ScreendoorBlock;
